import AifPmsPresenter from "@adapters/features/Markets/AIF-PMS/Presenters/AifPms";
import PaymentPresenter from "@adapters/features/Markets/AIF-PMS/Presenters/Payment";
import PurchasePresenter from "@adapters/features/Markets/AIF-PMS/Presenters/Purchase";
import DraftPresenter from "@adapters/features/Markets/AIF-PMS/Presenters/Draft";
import GlobalPresenter from "@adapters/features/Markets/AIF-PMS/Presenters/Global";
import OrderBookPresenter from "@adapters/features/Markets/AIF-PMS/Presenters/OrderBook";
import LeadServicePresenter from "@adapters/features/Markets/AIF-PMS/Presenters/LeadService";
import QualityCheckPresenter from "@adapters/features/Markets/AIF-PMS/Presenters/QualityCheck";
export default (function (useCases, actions) {
    return {
        aifPms: new AifPmsPresenter(useCases.aifPms, actions.aifPms),
        payment: new PaymentPresenter(useCases.payment, actions.payment),
        purchase: new PurchasePresenter(useCases.purchase, actions.purchase),
        draft: new DraftPresenter(useCases.draft, actions.draft),
        global: new GlobalPresenter(useCases.global, actions.global),
        orderBook: new OrderBookPresenter(useCases.orderBook, actions.orderBook),
        leadservice: new LeadServicePresenter(useCases.leadservice, actions.leadservice),
        qualityCheck: new QualityCheckPresenter(useCases.qualityCheck, actions.qualityCheck),
    };
});
